// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3Z8Gb","paramInput":"JobSimulator_paramInput__3HWZR","input":"JobSimulator_input__1Pt1v"};